import { Button, Picture, TextPassage } from '@petsmart-ui/sparky';
import { ContentfulClick } from '@libs/analytics';
import Link from 'next/link';
import cn from 'classnames';
import { NEW_TAB, PRIMARY_BUTTON_STYLE, SECONDARY_BUTTON_STYLE, TARGET_BLANK, TARGET_SELF } from '../../constants';
import { propsImageItems } from '../../utils/propsImagesItems';

import type { CampaignHeroVariantProps } from './types';
import './CampaignHeroFullWidth.scss';

export default function CampaignHeroFullWidth({
    header,
    body,
    primaryTextColor,
    image,
    cta,
    internalTitle,
}: CampaignHeroVariantProps) {
    const imageItems = propsImageItems(image, true);
    const Container = cta ? Link : 'div';

    return (
        <ContentfulClick
            component={Container}
            className={cn('campaign-hero-fwidth', {
                'campaign-hero-fwidth__grey': primaryTextColor === 'Dark Grey',
                'campaign-hero-fwidth__red': primaryTextColor === 'Dark Grey w/ Red',
            })}
            target={cta?.behavior === NEW_TAB ? TARGET_BLANK : TARGET_SELF}
            href={cta?.link.webUrl ?? ''}
            prefetch={false}
            eventData={{
                linkText: cn(header, body, cta?.text),
                linkUrl: cta?.link.webUrl ?? '',
                promoTitle: header,
                promoVariant: 'campaign hero - full-width',
                promoDesc: internalTitle,
                promoType: 'campaign-hero-fwidth',
            }}
        >
            <Picture imgAlt={image.webAltText} imgSrc={imageItems[0]?.srcSet} items={imageItems} />

            <div className="campaign-hero-fwidth__body">
                <TextPassage className="campaign-hero-fwidth__heading">{header}</TextPassage>
                {body && <TextPassage className="campaign-hero-fwidth__text">{body}</TextPassage>}
                {cta && (
                    <Button
                        variant={
                            cta.buttonStyle.toLowerCase() === 'primary' ? PRIMARY_BUTTON_STYLE : SECONDARY_BUTTON_STYLE
                        }
                        text={cta.text}
                        size="lg"
                    />
                )}
            </div>
        </ContentfulClick>
    );
}
